<template>
  <div class="indicator">
    <div>
      <div class="indicator-compare"><span>1. 情報入力</span></div>
      <div class="indicator-confirm"><span>2. 確認</span></div>
      <div class="indicator-thanks"><span>3. 完了</span></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.indicator {
  border-top: 1px solid #CCCCCC;
  border-bottom: 1px solid #CCCCCC;
  width: 100%;
  background-color: #FFF;
  top: -100%;
  transition: .8s;

  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 80;
  }

  &.fixed + .offer {
    margin-top: 8%;
  }

  > div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: px(12);
    overflow: hidden;

    > div {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      > span {
        padding: 8.94% 0 ;
        display: block;
        color: #1C79C6;
        font-weight: bold;
        text-align: center;
        line-height: 1.2;
        box-sizing: border-box;

        &::before,
        &::after {
          content: "";
          width: 0;
          height: 0;
          position: absolute;
          z-index: 9;
        }
      }

      &::before,
      &::after {
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        z-index: 9;
        border-style: solid;
        border-width: 2em 0 2em 0.6em;
        top: 50%;
        -ms-transform: translate(100%,-50%);
        transform: translate(100%,-50%);
      }
      &::before {
        border-color: transparent transparent transparent #DBDBDB;
        right: -1px;
      }
      &::after {
        border-color: transparent transparent transparent #FFF;
        right: 0;
      }
    }
    // 最後の矢印や最初の三角形を消す
    > div:last-child::before,
    > div:last-child::after,
    > div:first-child > span::before,
    > div:last-child > span::after {
      display: none;
    }
  }
}

/* 現在地などactive用（bodyクラスにより色分岐） */
body.compare {
  .indicator > div > .indicator-compare {
    background-color: $colorCompareBlue;

    > span {
      color: #FFF;
      &::after {
        border-style: solid;
        border-color: transparent transparent transparent $colorCompareBlue;
        border-width: 2em 0 2em 0.6em;
        top: 50%;
        right: 0;
        -ms-transform: translate(100%,-50%);
        transform: translate(100%,-50%);
      }
    }
    &::after {
      border-color: transparent transparent transparent $colorCompareBlue;
    }
  }
}

body.confirm {
  .indicator > div > .indicator-confirm {
    background-color: $colorCompareBlue;

    > span {
      color: #FFF;
      &::before {
        border-style: solid;
        border-color: transparent transparent transparent #FFF;
        border-width: 2em 0 2em 0.6em;
        top: 50%;
        left: 0;
        -ms-transform: translate(-0,-50%);
        transform: translate(-0,-50%);
      }
      &::after {
        border-style: solid;
        border-color: transparent transparent transparent $colorCompareBlue;
        border-width: 2em 0 2em 0.6em;
        top: 50%;
        right: 0;
        -ms-transform: translate(100%,-50%);
        transform: translate(100%,-50%);
      }
    }
    &::after {
      border-color: transparent transparent transparent $colorCompareBlue;
    }
  }
}

body.thanks {
  .indicator > div > .indicator-thanks {
    background-color: $colorCompareBlue;

    > span {
      color: #FFF;
      &::before {
        border-style: solid;
        border-color: transparent transparent transparent #FFF;
        border-width: 2em 0 2em 0.6em;
        top: 50%;
        left: 0;
        -ms-transform: translate(-0,-50%);
        transform: translate(-0,-50%);
      }
      &::after {
        border-style: solid;
        border-color: transparent transparent transparent $colorCompareBlue;
        border-width: 2em 0 2em 0.6em;
        top: 50%;
        right: 0;
        -ms-transform: translate(100%,-50%);
        transform: translate(100%,-50%);
      }
    }
  }
}

@include media(pc) {
  .indicator {
    padding: 2px 0;
    width: 100%;

    > div {
      margin: 0 auto;
      width: 854px;
      font-size: px(14);

      > div > span {
        padding: 18px 0;
      }
    }
  }
  body.compare {
    .indicator > div > .indicator-thanks {
      border-right: 1px solid #CCCCCC;
    }
  }
  body.confirm {
    .indicator > div > .indicator-compare {
      border-left: 1px solid #CCCCCC;
    }
    .indicator > div > .indicator-thanks {
      border-right: 1px solid #CCCCCC;
    }
  }
  body.thanks {
    .indicator > div > .indicator-compare {
      border-left: 1px solid #CCCCCC;
    }
  }
}
</style>